module.exports = __webpack_public_path__ + "static/media/  (63).0c7456a7.jpg";